import {
  createFileRoute,
  lazyRouteComponent,
  notFound,
} from "@tanstack/react-router";
import { IS_MIX_CATALOG } from "@/config/browserBoard";

export const Route = createFileRoute("/thread/$threadId")({
  beforeLoad: () => {
    if (IS_MIX_CATALOG) throw notFound();
  },
  component: lazyRouteComponent(
    () => import("@/pages/ThreadPage"),
    "ThreadPage",
  ),
});
